import { normalizeSectionId, sectionRenderer } from "@theme/section-renderer";
class VariantPickerForm extends HTMLElement {
  #section = null;
  connectedCallback() {
    this.#section = this.closest("[id^='shopify-section-']");
    this.addEventListener("click", this.#onClick);
  }
  disconnectedCallback() {
    this.removeEventListener("click", this.#onClick);
  }
  #onClick = (event) => {
    if (event.defaultPrevented) return;
    if (event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }
    const target = event.target;
    if (!(target instanceof Element)) return;
    const anchor = target.closest("a[data-axis]");
    if (!anchor) return;
    const href = anchor.getAttribute("href");
    if (!href) return;
    const section = this.#section;
    if (!section) return;
    event.preventDefault();
    const url = new URL(href, window.location.href);
    const historyMethod = anchor.dataset.axis === "color" ? "pushState" : "replaceState";
    history[historyMethod]({}, "", url.toString());
    void sectionRenderer.renderSection(normalizeSectionId(section.id), { url });
  };
}
if (!customElements.get("variant-picker-form")) {
  customElements.define("variant-picker-form", VariantPickerForm);
}
